export const namespaced = true
// const log = console.log
export const state = {
  notifications: []
}

let nextId = 1
export const mutations = {
  PUSH(state, notification) {
    // log('Notification:' + JSON.stringify(notification))
    state.notifications.push({
      ...notification,
      id: nextId++
    })
  },
  DELETE(state, notificationToRemove) {
    state.notifications = state.notifications.filter(
      notification => notification.id !== notificationToRemove.id
    )
  }
}
export const actions = {
  add({ commit }, notification) {
    if (notification.code === 'auth/user-not-found') {
      notification.message = `We can't find your email address, please register with this this email address to continue`
    }
    if (notification.code === 'auth/wrong-password') {
      notification.message = `The password is invalid, reset your password if you have forgotten your password`
    }
    commit('PUSH', notification)
  },
  remove({ commit }, notificationToRemove) {
    commit('DELETE', notificationToRemove)
  }
}
